import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { setAuthFormTexts } from 'store/reducers/layoutReducer'
import { useAppDispatch } from 'store/store'

export const setFormTranslatedText = (page: string) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation('', {
    keyPrefix: `pages.${page}`,
  })

  const translatedText = useMemo(
    () => ({
      title: page ? t('title') : '',
      subtitle: page ? t('subtitle') : '',
    }),
    [page, t],
  )

  useEffect(() => {
    dispatch(setAuthFormTexts(translatedText))
  }, [dispatch, translatedText])
}
